import React, { Component, Fragment } from 'react'
import cx from 'classnames'
import draftToHtml from 'draftjs-to-html'
import { Editor, EditorState, RichUtils, convertToRaw, ContentState, convertFromHTML } from 'draft-js'

import s from './PlainEditor.scss'


const getText = (data) => draftToHtml(convertToRaw(data.getCurrentContent()))

const getDraft = (data) => {
  const blocksFromHTML = convertFromHTML(data)
  const state = ContentState.createFromBlockArray(
    blocksFromHTML.contentBlocks,
    blocksFromHTML.entityMap,
  )

  return EditorState.createWithContent(state)
}

export default class RichEditorExample extends Component {
  
  constructor(props) {
    super(props)

    console.log(getDraft(props.valueLink.value))
    this.state = {
      editorState: props.valueLink && props.valueLink.value
        ? getDraft(props.valueLink.value)
        : EditorState.createEmpty()
    }

    this.handleKeyCommand = (command) => this._handleKeyCommand(command)
    this.onTab = (e) => this._onTab(e)
    this.toggleBlockType = (type) => this._toggleBlockType(type)
    this.toggleInlineStyle = (style) => this._toggleInlineStyle(style)
  }

  focus = () => this.refs.editor.focus()

  onChange = (editorState) => {
    const { valueLink } = this.props
    // TODO FIX unset of image values
    window.valueLink = valueLink
    valueLink.set(getText(editorState))

    this.setState({
      editorState,
    })
  }

  _handleKeyCommand(command) {
    const { editorState } = this.state

    const newState = RichUtils.handleKeyCommand(editorState, command)
    if (newState) {
      this.onChange(newState)
      return true
    }
    return false
  }

  _onTab(e) {
    const maxDepth = 4
    this.onChange(RichUtils.onTab(e, this.state.editorState, maxDepth))
  }

  _toggleBlockType(blockType) {
    this.onChange(
      RichUtils.toggleBlockType(
        this.state.editorState,
        blockType
      )
    )
  }

  _toggleInlineStyle(inlineStyle) {
    this.onChange(
      RichUtils.toggleInlineStyle(
        this.state.editorState,
        inlineStyle
      )
    )
  }

  render() {
    const { editorState } = this.state
    const { placeholder } = this.props

    // If the user changes block type before entering any text, we can
    // either style the placeholder or hide it. Let's just hide it now.
    let className = s.editor
    // const contentState = editorState.getCurrentContent()

    // if (!contentState.hasText()) {
    //   if (contentState.getBlockMap().first().getType() !== 'unstyled') {
    //     className += ` ${s.hidePlaceholder}`
    //   }
    // }

    return (
      <Fragment>
        {/*<BlockStyleControls*/}
        {/*  editorState={editorState}*/}
        {/*  onToggle={this.toggleBlockType}*/}
        {/*/>*/}
        <InlineStyleControls
          editorState={editorState}
          onToggle={this.toggleInlineStyle}
        />
        <div className={className} onClick={this.focus}>
          <Editor
            blockStyleFn={getBlockStyle}
            customStyleMap={{
              // CODE: {
              //   backgroundColor: 'rgba(0, 0, 0, 0.05)',
              //   fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
              //   fontSize: 16,
              //   padding: 2,
              // },
            }}
            editorState={editorState}
            handleKeyCommand={this.handleKeyCommand}
            onChange={this.onChange}
            onTab={this.onTab}
            placeholder={placeholder}
            ref="editor"
            spellCheck={true}
          />
        </div>
      </Fragment>
    )
  }
}

function getBlockStyle(block) {
  switch (block.getType()) {
    case 'blockquote': return s.blockquote
    default: return null
  }
}

class StyleButton extends Component {

  constructor() {
    super()

    this.onToggle = (e) => {
      e.preventDefault()
      this.props.onToggle(this.props.style)
    }
  }

  render() {
    const { label, active } = this.props

    return (
      <span
        className={cx(s.styleButton, {
          [s.activeButton]: active,
        })}
        onMouseDown={this.onToggle}
        dangerouslySetInnerHTML={{ __html: label }}
      />
    )
  }
}

// const BLOCK_TYPES = [
//   {label: 'H1', style: 'header-one'},
//   {label: 'H2', style: 'header-two'},
//   {label: 'H3', style: 'header-three'},
//   {label: 'H4', style: 'header-four'},
//   {label: 'H5', style: 'header-five'},
//   {label: 'H6', style: 'header-six'},
//   {label: 'Blockquote', style: 'blockquote'},
//   {label: 'UL', style: 'unordered-list-item'},
//   {label: 'OL', style: 'ordered-list-item'},
//   {label: 'Code Block', style: 'code-block'},
// ]
//
// const BlockStyleControls = (props) => {
//   const {editorState} = props
//   const selection = editorState.getSelection()
//   const blockType = editorState
//     .getCurrentContent()
//     .getBlockForKey(selection.getStartKey())
//     .getType()
//
//   return (
//     <div className={s.controls}>
//       {
//         BLOCK_TYPES.map((type) =>
//           <StyleButton
//             key={type.label}
//             active={type.style === blockType}
//             label={type.label}
//             onToggle={props.onToggle}
//             style={type.style}
//           />
//         )
//       }
//     </div>
//   )
// }

const INLINE_STYLES = [
  {label: '<b style="font-weight: 600;">Ж</b>', style: 'BOLD'},
  {label: '<i>К</i>', style: 'ITALIC'},
  {label: '<u>Ч</u>', style: 'UNDERLINE'},
  // {label: 'Monospace', style: 'CODE'},
]

const InlineStyleControls = ({ editorState, onToggle }) => {
  const currentStyle = editorState.getCurrentInlineStyle()

  return (
    <div className={s.controls}>
      {
        INLINE_STYLES.map(({ label, style }) =>
          <StyleButton
            key={label}
            active={currentStyle.has(style)}
            label={label}
            onToggle={onToggle}
            style={style}
          />
        )
      }
    </div>
  )
}
